module.exports = __webpack_public_path__ + "static/img/img-04.2bf7c85f.png";